import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { TranslateModule } from "@ngx-translate/core";
import { AnimateOnScrollDirective } from "./directives/animate-on-scroll.directive";
import { AwardTitleComponent } from './components/award-title/award-title.component';
import { AwardeeModalComponent } from './components/awardee-modal/awardee-modal.component';
import { CorporateAwardsBoxComponent } from './components/corporate-awards-box/corporate-awards-box.component';
import { CompanyLogoSectionComponent } from './components/company-logo-section/company-logo-section.component';
import { IndividualAwardsBoxComponent } from './components/individual-awards-box/individual-awards-box.component';
import { HighlightsModalComponent } from './components/highlights-modal/highlights-modal.component';
import { GalleryModalComponent } from './components/gallery-modal/gallery-modal.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgZorroAntdModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        AnimateOnScrollDirective,
        AwardTitleComponent,
        AwardeeModalComponent,
        CorporateAwardsBoxComponent,
        CompanyLogoSectionComponent,
        IndividualAwardsBoxComponent,
        HighlightsModalComponent,
        GalleryModalComponent,
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgZorroAntdModule,
        TranslateModule,
        ReactiveFormsModule,
        AnimateOnScrollDirective,
        AwardTitleComponent,
        AwardeeModalComponent,
        CorporateAwardsBoxComponent,
        CompanyLogoSectionComponent,
        IndividualAwardsBoxComponent,
        HighlightsModalComponent,
        GalleryModalComponent
    ],
    providers: []
})
export class SharedModule {}
